#!/usr/bin/env node
import fs from 'fs';
import yargs from 'yargs';
import { hideBin } from 'yargs/helpers';

yargs(hideBin(process.argv))
  .command(
    'write-versions',
    'write build information',
    {
      'build-id': {
        default: '0000',
        description: 'id of build',
      },
      env: {
        default: 'tx',
        description: 'environment build was run on',
      },
      branch: {
        default: 'xxxx',
        description: 'the git branch being built',
      },
    },
    argv => {
      const target = 'dist/versions.js';
      const targetJSON = 'dist/versions.json';
      let json = '{}';
      if (fs.existsSync(targetJSON)) {
        json = fs.readFileSync(targetJSON, 'utf8');
      }

      const outputJson = JSON.stringify({
        ...JSON.parse(json),
        'build-id': argv['build-id'],
        env: argv.env,
        branch: argv.branch,
      });

      fs.writeFileSync(target, `export default ${outputJson}`, 'utf8');
      fs.writeFileSync(targetJSON, outputJson, 'utf8');
    },
  )
  .parse();
